/* ==========================================================================
   Multi-column Slider (Sitting Pretty)
   Swiper card carousel — mirrors the Shoppable UGC grid slider.
   Requires Swiper 11 (loaded via the theme asset before this file).
   ========================================================================== */
(function () {
  'use strict';

  function initRoot(root) {
    if (!root || root.dataset.spColsliderReady === 'true' || !window.Swiper) return;
    root.dataset.spColsliderReady = 'true';

    var gridEl = root.querySelector('.sp-colslider__grid');
    if (!gridEl) return;

    var perView = parseInt(root.getAttribute('data-per-view'), 10) || 3;

    new window.Swiper(gridEl, {
      slidesPerView: 1.667,
      spaceBetween: 12,
      watchOverflow: true,
      a11y: { enabled: true },
      navigation: {
        prevEl: root.querySelector('.sp-colslider__arrow--prev'),
        nextEl: root.querySelector('.sp-colslider__arrow--next')
      },
      breakpoints: {
        750: { slidesPerView: 2.5, spaceBetween: 14 },
        1000: { slidesPerView: perView, spaceBetween: 16 }
      }
    });
  }

  function bootAll() {
    document.querySelectorAll('[data-sp-colslider]').forEach(initRoot);
  }

  function whenSwiper(cb) {
    if (window.Swiper) return cb();
    var tries = 0;
    var timer = setInterval(function () {
      if (window.Swiper || tries++ > 120) {
        clearInterval(timer);
        if (window.Swiper) cb();
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { whenSwiper(bootAll); });
  } else {
    whenSwiper(bootAll);
  }

  // Theme editor: (re)initialise when the section loads
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sp-colslider]');
    if (root) whenSwiper(function () { initRoot(root); });
  });
})();
